import { render, staticRenderFns } from "./melli.vue?vue&type=template&id=42f5f09e&scoped=true"
import script from "./melli.vue?vue&type=script&lang=js"
export * from "./melli.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f5f09e",
  null
  
)

export default component.exports